import React from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/cjs/styles/prism";

const CodeSnippet = (props) => {
    return (
        <div
            className="overflow-scroll code-snippet"
            style={{
                maxHeight: "calc(100vh - 122px)",
            }}
        >
            <SyntaxHighlighter language={props.language} showLineNumbers={true} style={vscDarkPlus}>
                {props.codeString}
            </SyntaxHighlighter>
        </div>
    );
};

export default CodeSnippet;
